import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { useRouter } from 'next/navigation'

import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'

import { WidgetsVariant } from './types'
import type { WidgetBase } from './types'

const REFER_FRIEND_WIDGET_DATA_MODEL = process.env.CMS_DATA_MODEL_REFER_FRIEND_WIDGET

export const useReferFriendWidget = (): WidgetBase => {
  const router = useRouter()
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)

  const { builderData: referFriendData, builderDataLoaded } = useBuilderCMSData(REFER_FRIEND_WIDGET_DATA_MODEL)

  const builderData = referFriendData[0]?.data
  const hasBuilderData = !!builderData?.imageUrl && !!builderData?.pageUrl

  const handleReferFriendClick = () => {
    if (!builderData?.pageUrl) {
      return
    }
    nextTick().then(() => {
      trackEvent('refer_friend_widget_clicked')
      router.push(builderData.pageUrl)
    })
  }

  return {
    id: WidgetsVariant.REFER_A_FRIEND,
    isWidgetVisible: isScEnabled && hasBuilderData && builderDataLoaded,
    imgSrc: builderData?.imageUrl,
    imgAlt: builderData?.imageAlt || 'Refer a Friend',
    onClick: handleReferFriendClick,
  }
}
